import * as React from "react";
import { Controller } from "react-hook-form";
import { Label } from "../../../../components/ui/label";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
  SelectLabel,
  SelectGroup,
} from "../../../../components/ui/select";
import { FieldError } from "../FieldError";

const YES_NO = [
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
];

export function HasLossRuns({ control }) {
  return (
    <div className="space-y-2">
      <Label>
        Do you have at least 3 years of loss runs for the insured or 2 years of
        loss runs in the event the insured has only operated under this DOT #
        for 2 years? (Dated within the last 30 days)
      </Label>
      <Controller
        control={control}
        name="step2.hasLossRuns"
        render={({ field }) => (
          <Select
            value={field.value === "na" ? "" : (field.value ?? "")}
            onValueChange={(v) => {
              field.onChange(v);
            }}
            onOpenChange={() => {
              field.onChange(field.value ?? "");
            }}
          >
            <SelectTrigger
              className={"w-full"}
            >
              <SelectValue placeholder="Select" />
            </SelectTrigger>
            <SelectContent className="max-h-60 overflow-y-auto">
              <SelectGroup>
                <SelectLabel>Choose</SelectLabel>
                {YES_NO.map((opt) => (
                  <SelectItem key={opt.value} value={opt.value}>
                    {opt.label}
                  </SelectItem>
                ))}
              </SelectGroup>
            </SelectContent>
          </Select>
        )}
      />
      <FieldError name="step2.hasLossRuns" step="step2" control={control} />
    </div>
  );
}
